import { ko } from 'date-fns/locale/ko';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Link, useSearchParams } from 'react-router-dom';
import { putMAEAA010updatePosition, postMAEAA010, putMAFAA030Limit } from '../../../services/Api';
import momentDate from '../../../shared/components/MomentDate';
import Pagination from '../../../shared/components/Pagination';
import SideMenu from '../../../shared/components/SideMenu';
import { MENU_BANNERS } from '../../../shared/constants/app';
import { formatDate, formatHomeUrl, formatNumberWithCommas, getImageSrc, getImgFolder } from '../../../utils';
registerLocale('ko', ko);

const MAEAA010 = () => {
    const startDateRef = useRef();
    const endDateRef = useRef();
    const [data, setData] = useState([]);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const [selectedOption, setSelectedOption] = useState('MAIN');
    const [selectedOptionTwo, setSelectedOptionTwo] = useState('');
    const [status, setStatus] = useState('');
    const [useYn, setUseYn] = useState('');
    const [dateRate, setDateRate] = useState('');
    const [keyword, setKeyword] = useState('');

    const [searchParams, setSearchParams] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;
    const [pages, setPages] = useState({});
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [valueChangePosition, setValueChangePosition] = useState(() => {
        if (selectedOptionTwo === 'RECRUIT') {
            return data?.bannerConfigRecruit?.grandCnt || '';
        } else if (selectedOptionTwo === 'RESUME') {
            return data?.bannerConfigResume?.grandCnt || '';
        }
        return '';
    });
    const [adPosition, setAdPosition] = useState([]);

    useEffect(() => {
        if (selectedOptionTwo === 'RECRUIT') {
            setValueChangePosition(data?.bannerConfigRecruit?.grandCnt || '');
        } else if (selectedOptionTwo === 'RESUME') {
            setValueChangePosition(data?.bannerConfigResume?.grandCnt || '');
        } else {
            setValueChangePosition('');
        }
    }, [selectedOptionTwo, data]);
    const handlePopupClose = () => {
        setIsPopupVisible(false);
    };
    const handlePopupOpen = () => {
        setIsPopupVisible(true);
    };
    const onChangeValuePosition = (e) => {
        setValueChangePosition(e.target.value);
    };
    const handleChangeValuePosition = async () => {
        const isConfirm = window.confirm('줄광고 노출위치 변경하시겠습니까?');
        if (isConfirm) {
            await putMAFAA030Limit({
                typeBanner: selectedOptionTwo || '',
                changeCount: valueChangePosition || '',
            })
                .then(() => {
                    getListData();
                    window.alert('변경되었습니다.');
                    handlePopupClose();
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    };

    const handleDateRange = (e) => {
        const valueRangeDate = e.target.getAttribute('value-date-range');
        setDateRate(valueRangeDate);
        const today = moment().format('YYYY-MM-DD');
        const dateMoment = momentDate(today, valueRangeDate);
        setStartDate(dateMoment);
        setEndDate(today);
    };

    const handleDateChange = (date, name) => {
        setDateRate('');
        if (name === 'startDate') {
            setStartDate(date);
        } else if (name === 'endDate') {
            setEndDate(date);
        }
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'adType1') {
            setSelectedOption(value);
            const options = getSecondSelectOptions(value);
            setSelectedOptionTwo(options?.length > 0 ? options[0].value : '');
        } else if (name === 'adType2') setSelectedOptionTwo(value);
        else if (name === 'status') setStatus(value);
        else if (name === 'useYn') setUseYn(value);
    };

    const getAdPosition = (type) => {
        switch (type) {
            case 'MAIN':
                return '메인';
            case 'MAINTOP':
                return '메인';
            case 'GRAND':
                return '메인';
            case 'GRANDSUB':
                return '메인';
            case 'PREMIUM':
                return '메인';
            case 'CORP':
                return '메인';
            case 'MAINRESUME':
                return '메인';
            case 'RECRUIT':
                return '서브';
            case 'RESUME':
                return '서브';
            case 'LNB':
                return '서브';
            default:
                return '기타';
        }
    };

    const getStatusText = (startDate, endDate) => {
        const now = new Date();

        const start = new Date(startDate);
        const end = new Date(endDate);
        end.setHours(23, 59, 59, 999);

        if (now >= start && now <= end) {
            return '진행중';
        } else if (now < start) {
            return '진행예정';
        } else {
            return '마감';
        }
    };

    const getSecondSelectOptions = (option) => {
        switch (option) {
            case 'MAIN':
                return [
                    { value: '', text: '전체' },
                    { value: 'MAIN', text: '메인' },
                    { value: 'MAINTOP', text: '메인 TOP 배너' },
                    { value: 'GRAND', text: '그랜드 배너' },
                    { value: 'GRANDSUB', text: '그랜드 서브 배너' },
                    { value: 'PREMIUM', text: '프리미엄 배너' },
                    { value: 'CORP', text: '기업 배너' },
                    { value: 'MAINRESUME', text: 'HOT 인재 배너' },
                ];
            case 'SUB':
                return [
                    { value: 'RECRUIT', text: '채용정보 줄 배너' },
                    { value: 'RESUME', text: '인재소식 줄 배너' },
                    { value: 'LNB', text: '좌측 LNB 하단 배너' },
                ];
            case 'ETC':
                return [
                    { value: 'LOGIN', text: '로그인 배너' },
                    { value: 'QUICK', text: '우측 퀵 배너' },
                ];
            default:
                return [];
        }
    };

    const getAdType = (type) => {
        switch (type) {
            case 'GRAND':
                return '그랜드배너광고 위치';
            case 'GRANDSUB':
                return '그랜드배너광고 하단에 위치';
            case 'LOGIN':
                return '로그인 부분에 위치';
            case 'MAIN':
                return '중앙 메인광고 위치';
            case 'CORP':
                return '기업배너광고 위치';
            case 'MAINRESUME':
                return '메인화면하단이력서 줄배너광고';
            case 'MAINTOP':
                return '메인 맨 상단 팝업광고';
            case 'PREMIUM':
                return '프리미엄배너 부분 광고';
            case 'RECRUIT':
                return '일반채용 부분 줄광고';
            case 'RESUME':
                return '인재정보 줄 배너';
            case 'QUICK':
                return '우측 퀵 배너';
            case 'LNB':
                return '좌측 LNB 하단 배너';
            default:
                return '';
        }
    };

    // useEffect(() => {
    //     const options = getSecondSelectOptions(selectedOption);
    //     setSelectedOptionTwo(options?.length > 0 ? options[0].value : '');
    // }, [selectedOption]);
    const getListData = async (currentPage = page) => {
        await postMAEAA010({
            page: currentPage,
            startDate: startDate ? moment(startDate).format('YYYY-MM-DD') : undefined,
            endDate: endDate ? moment(endDate).format('YYYY-MM-DD') : undefined,
            keyword: keyword?.trim(),
            status,
            adType: selectedOptionTwo,
            options: useYn ? { UseYN: [useYn] } : undefined,
        })
            .then(({ data }) => {
                setData(data.data);
                setPages(data.info);
            })
            .catch((error) => console.log(error));
    };

    const clickSearch = () => {
        setSearchParams({
            page: 1,
            startDate: startDate ? moment(startDate).format('YYYY-MM-DD') : '',
            endDate: endDate ? moment(endDate).format('YYYY-MM-DD') : '',
            keyword: keyword || '',
            status: status || '',
            adType1: selectedOption || 'MAIN',
            adType2: selectedOptionTwo || '',
            useYn: useYn || '',
            dateRate: dateRate || '',
        });
        getListData(1);
    };

    const clickReset = () => {
        setSearchParams({});
        setStartDate('');
        setEndDate('');
        setDateRate('');
        setSelectedOption('MAIN');
        setSelectedOptionTwo('');
        setKeyword('');
        setStatus('');
        setUseYn('');
    };

    // useEffect(() => {
    //     getListData();
    //     // eslint-disable-next-line
    // }, [page]);

    useEffect(() => {
        if (data?.list && Array.isArray(data.list)) {
            const initialPositions = data.list
                .filter((item) => item.seq !== undefined && item.adPosition !== undefined)
                .map((item) => parseInt(item.adPosition, 10));
            setAdPosition(initialPositions);
        } else {
            setAdPosition([]);
        }
    }, [data]);

    const handleChangePosition = (e, idx) => {
        const value = parseInt(e.target.value, 10);
        setAdPosition((prev) => {
            const updated = [...prev];
            updated[idx] = value;
            return updated;
        });
    };

    const handleUpdatePosition = async () => {
        if (!data?.list || !Array.isArray(data.list) || data.list.length === 0) {
            return;
        }

        const seqListPayload = data.list.map((item) => item.seq);

        const payload = {
            seqList: seqListPayload,
            adPositionList: adPosition.map((pos) => (isNaN(pos) ? 1 : pos)),
        };

        try {
            await putMAEAA010updatePosition(payload);
            window.alert('순서가 변경되었습니다.');
            getListData();
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const params = Object.fromEntries(searchParams.entries());

                setStartDate(params.startDate ? moment(params.startDate).format('YYYY-MM-DD') : '');
                setEndDate(params.endDate ? moment(params.endDate).format('YYYY-MM-DD') : '');
                setKeyword(params.keyword || '');
                setStatus(params.status || '');
                setSelectedOption(params.adType1 || 'MAIN');
                setSelectedOptionTwo(params.adType2 || '');
                setUseYn(params.useYn || '');
                setDateRate(params.dateRate || '');
                const { data } = await postMAEAA010({
                    page: page,
                    startDate: params.startDate ? moment(params.startDate).format('YYYY-MM-DD') : undefined,
                    endDate: params.endDate ? moment(params.endDate).format('YYYY-MM-DD') : undefined,
                    keyword: params.keyword || '',
                    status: params.status || '',
                    adType: params.adType2 || '',
                    options: params.useYn ? { UseYN: [params.useYn] } : undefined,
                });

                setData(data.data);
                setPages(data.info);
            } catch (error) {
                console.log(error);
            }
        };

        fetchData();
        // eslint-disable-next-line
    }, [searchParams]);
    return (
        <>
            <div className="container">
                <div className="wrap content">
                    <SideMenu menu={MENU_BANNERS} />
                    <div className="manager-banner-content content-right">
                        <div className="title title-manager-banner">광고관리</div>
                        <div id="manager-banner-content-list">
                            <table className="table-gray">
                                <tbody>
                                    <tr>
                                        <th>조건검색</th>
                                        <td>
                                            <div className="select-box d-flex gap-2">
                                                <select name="adType1" onChange={handleChange} value={selectedOption}>
                                                    <option value="MAIN">메인</option>
                                                    <option value="SUB">서브</option>
                                                    <option value="ETC">기타</option>
                                                </select>
                                                <select
                                                    name="adType2"
                                                    onChange={handleChange}
                                                    value={selectedOptionTwo}
                                                >
                                                    {getSecondSelectOptions(selectedOption).map((option) => (
                                                        <option key={option.value} value={option.value}>
                                                            {option.text}
                                                        </option>
                                                    ))}
                                                </select>
                                                <div>
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '20px',
                                                        }}
                                                        className={`${selectedOptionTwo === 'RECRUIT' ||
                                                            selectedOptionTwo === 'RESUME'
                                                            ? ''
                                                            : 'opacity-0'
                                                            }`}
                                                    >
                                                        <span>
                                                            줄광고 노출위치 :{' '}
                                                            {selectedOptionTwo === 'RECRUIT'
                                                                ? data?.bannerConfigRecruit?.grandCnt
                                                                : data?.bannerConfigResume?.grandCnt}{' '}
                                                            번째
                                                        </span>
                                                        <button
                                                            className="btn btn-gray-thin"
                                                            style={{ width: 'max-content', fontSize: '14px' }}
                                                            onClick={handlePopupOpen}
                                                        >
                                                            줄광고 노출위치 변경
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <th>배너명</th>
                                        <td>
                                            <input
                                                style={{ width: '350px' }}
                                                type="text"
                                                placeholder="배너명 입력"
                                                value={keyword}
                                                onChange={(e) => setKeyword(e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        clickSearch();
                                                    }
                                                }}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>상태</th>
                                        <td>
                                            <div className="checkbox-group">
                                                <fieldset id="status" className="radio-group">
                                                    <div className="item-radioBox">
                                                        <input
                                                            type="radio"
                                                            name="status"
                                                            value="PLA"
                                                            id="PLA"
                                                            checked={status === 'PLA'}
                                                            onChange={handleChange}
                                                        />
                                                        <span />
                                                        <label htmlFor="PLA">
                                                            <span>진행예정</span>
                                                        </label>
                                                    </div>
                                                    <div className="item-radioBox">
                                                        <input
                                                            type="radio"
                                                            name="status"
                                                            value="PRO"
                                                            id="PRO"
                                                            checked={status === 'PRO'}
                                                            onChange={handleChange}
                                                        />
                                                        <span />
                                                        <label htmlFor="PRO">
                                                            <span>진행중</span>
                                                        </label>
                                                    </div>
                                                    <div className="item-radioBox">
                                                        <input
                                                            type="radio"
                                                            name="status"
                                                            value="END"
                                                            id="END"
                                                            checked={status === 'END'}
                                                            onChange={handleChange}
                                                        />
                                                        <span />
                                                        <label htmlFor="END">
                                                            <span>마감</span>
                                                        </label>
                                                    </div>
                                                </fieldset>
                                            </div>
                                        </td>
                                        <th className="border-b-ddd">공개 여부</th>
                                        <td>
                                            <fieldset id="useYn" className="radio-group">
                                                <div className="item-radioBox">
                                                    <input
                                                        type="radio"
                                                        name="useYn"
                                                        value="ALL"
                                                        id="UseALL"
                                                        checked={useYn === 'ALL'}
                                                        onChange={handleChange}
                                                    />
                                                    <span />
                                                    <label htmlFor="UseALL">
                                                        <span>전체</span>
                                                    </label>
                                                </div>
                                                <div className="item-radioBox">
                                                    <input
                                                        type="radio"
                                                        name="useYn"
                                                        value="Y"
                                                        id="UseY"
                                                        checked={useYn === 'Y'}
                                                        onChange={handleChange}
                                                    />
                                                    <span />
                                                    <label htmlFor="UseY">
                                                        <span>공개</span>
                                                    </label>
                                                </div>
                                                <div className="item-radioBox">
                                                    <input
                                                        type="radio"
                                                        name="useYn"
                                                        value="N"
                                                        id="UseN"
                                                        checked={useYn === 'N'}
                                                        onChange={handleChange}
                                                    />
                                                    <span />
                                                    <label htmlFor="UseN">
                                                        <span>비공개</span>
                                                    </label>
                                                </div>
                                            </fieldset>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>등록일</th>
                                        <td colSpan={3}>
                                            <div className="flex group-item">
                                                <div className="group-datepicker">
                                                    <div className="datepicker-child">
                                                        <DatePicker
                                                            ref={startDateRef}
                                                            onChange={(date) => handleDateChange(date, 'startDate')}
                                                            locale={'ko'}
                                                            placeholderText={'YYYY/MM/DD'}
                                                            dateFormat={'yyyy/MM/dd'}
                                                            selected={startDate}
                                                            maxDate={endDate || null}
                                                        />
                                                        <i
                                                            className="icon icon-date"
                                                            id="start-date-icon"
                                                            onClick={() => startDateRef.current.setFocus()}
                                                        />
                                                    </div>
                                                    <span>~</span>
                                                    <div className="datepicker-child">
                                                        <DatePicker
                                                            ref={endDateRef}
                                                            onChange={(date) => handleDateChange(date, 'endDate')}
                                                            locale={'ko'}
                                                            placeholderText={'YYYY/MM/DD'}
                                                            dateFormat={'yyyy/MM/dd'}
                                                            selected={endDate}
                                                            minDate={startDate || null}
                                                        />
                                                        <i
                                                            className="icon icon-date"
                                                            id="end-date-icon"
                                                            onClick={() => endDateRef.current.setFocus()}
                                                        />
                                                    </div>
                                                </div>
                                                <ul className="select-value">
                                                    <li
                                                        value-date-range="today"
                                                        className={dateRate === 'today' ? 'active' : ''}
                                                        onClick={handleDateRange}
                                                    >
                                                        오늘
                                                    </li>
                                                    <li
                                                        value-date-range="1week"
                                                        className={dateRate === '1week' ? 'active' : ''}
                                                        onClick={handleDateRange}
                                                    >
                                                        일주일
                                                    </li>
                                                    <li
                                                        value-date-range="15days"
                                                        className={dateRate === '15days' ? 'active' : ''}
                                                        onClick={handleDateRange}
                                                    >
                                                        15일
                                                    </li>
                                                    <li
                                                        value-date-range="1month"
                                                        className={dateRate === '1month' ? 'active' : ''}
                                                        onClick={handleDateRange}
                                                    >
                                                        1개월
                                                    </li>
                                                    <li
                                                        value-date-range="3months"
                                                        className={dateRate === '3months' ? 'active' : ''}
                                                        onClick={handleDateRange}
                                                    >
                                                        3개월
                                                    </li>
                                                </ul>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div className="group-button center">
                                <button className="btn btn-gray-bold" onClick={clickSearch}>
                                    검색
                                </button>
                                <button className="btn btn-gray-thin" onClick={clickReset}>
                                    초기화
                                </button>
                            </div>
                        </div>
                        <div className="results table_MAEAA010">
                            <div className="before-table">
                                <div className="count-item">
                                    총 <span className="total">{formatNumberWithCommas(pages?.totalRow || 0)}</span>건
                                </div>
                                <div className="button-item">
                                    <Link to="/maeaa020">배너 등록</Link>
                                </div>
                            </div>

                            <table className="table-gray">
                                <thead>
                                    <tr>
                                        <th />
                                        <th>배너 분류</th>
                                        <th>배너 위치</th>
                                        <th>전시타입</th>
                                        <th>배너명</th>
                                        <th>
                                            순서
                                            <br />
                                            <button
                                                className="btn btn-gray-bold"
                                                style={{
                                                    width: 'max-content',
                                                    height: 'max-content',
                                                    padding: '0 5px',
                                                    fontSize: '14px',
                                                }}
                                                onClick={handleUpdatePosition}
                                            >
                                                변경
                                            </button>
                                        </th>
                                        <th>링크 url</th>
                                        <th>
                                            진행기간
                                            <br />
                                            (상태)
                                        </th>
                                        <th>공개여부</th>
                                        <th>노출수</th>
                                        <th>클릭수</th>
                                        <th>등록일</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data?.list && data?.list.length > 0 ? (
                                        data?.list.map((item, index) => (
                                            <React.Fragment key={'banner' + index}>
                                                <tr>
                                                    <td rowSpan={2}>{item.seq}</td>
                                                    <td rowSpan={2}>{getAdPosition(item.adType)}</td>
                                                    <td rowSpan={2}>
                                                        <Link
                                                            to={{
                                                                pathname: `/maeaa030-${item?.seq}`,
                                                                search: `?page=${page}&startDate=${startDate
                                                                    ? moment(startDate).format('YYYY-MM-DD')
                                                                    : ''
                                                                    }&endDate=${endDate ? moment(endDate).format('YYYY-MM-DD') : ''
                                                                    }&keyword=${keyword || ''}&status=${status || ''
                                                                    }&adType1=${selectedOption || 'MAIN'}&adType2=${selectedOptionTwo || ''
                                                                    }&useYn=${useYn || ''}&dateRate=${dateRate || ''}`,
                                                            }}
                                                        >
                                                            {getAdType(item.adType)}
                                                        </Link>
                                                    </td>
                                                    <td>웹</td>
                                                    <td>
                                                        <img
                                                            src={getImageSrc(
                                                                getImgFolder(item?.adType),
                                                                item?.imgNameMain,
                                                            )}
                                                            alt="Img"
                                                        />
                                                        <span className="image-name">{item.title}</span>
                                                    </td>
                                                    <td rowSpan={2}>
                                                        <input
                                                            style={{
                                                                width: '40px',
                                                                textAlign: 'center',
                                                                padding: '5px 10px',
                                                            }}
                                                            key={item.id}
                                                            value={isNaN(adPosition[index]) ? '' : adPosition[index]}
                                                            type="number"
                                                            onChange={(e) => handleChangePosition(e, index)}
                                                        />
                                                    </td>
                                                    <td>
                                                        {formatHomeUrl(item?.linkUrl) ? (
                                                            <a
                                                                style={{ cursor: 'pointer' }}
                                                                href={formatHomeUrl(item?.linkUrl)}
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                {item?.linkUrl}
                                                            </a>
                                                        ) : (
                                                            <span>{item?.linkUrl}</span>
                                                        )}
                                                    </td>
                                                    <td>
                                                        {item?.adType === 'MAINTOP' ? (
                                                            <>
                                                                <div>
                                                                    {moment(item?.startDate).format('YYYY.MM.DD HH:mm')}
                                                                    ~
                                                                </div>
                                                                <div>
                                                                    {moment(item?.endDate).format('YYYY.MM.DD HH:mm')}
                                                                </div>
                                                                {getStatusText(item.startDate, item.endDate)}
                                                            </>
                                                        ) : (
                                                            <>
                                                                {formatDate(item?.startDate)} ~
                                                                {formatDate(item?.endDate)}
                                                                <br />
                                                                {getStatusText(item.startDate, item.endDate)}
                                                            </>
                                                        )}
                                                    </td>
                                                    <td>{item?.useYN === 'Y' ? '공개' : '비공개'}</td>
                                                    <td>
                                                        {formatNumberWithCommas(
                                                            (item?.selectCnt || 0) - (item?.selectCntMb || 0)
                                                        )}
                                                    </td>
                                                    <td>
                                                        {formatNumberWithCommas(item?.visitedCnt)}
                                                    </td>
                                                    <td>{formatDate(item?.addDate)}</td>
                                                </tr>
                                                <tr>
                                                    <td>모바일</td>
                                                    <td>
                                                        <img
                                                            src={getImageSrc(
                                                                getImgFolder(item?.adType),
                                                                item?.imgNameAppMain320px,
                                                            )}
                                                            alt="App Img"
                                                        />
                                                        {item.title}
                                                    </td>
                                                    {/* <td>{item?.adPosition ? item?.adPosition : ''}</td> */}
                                                    <td>
                                                        {formatHomeUrl(item?.linkUrlApp) ? (
                                                            <a
                                                                style={{ cursor: 'pointer' }}
                                                                href={formatHomeUrl(item?.linkUrlApp)}
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                {item?.linkUrlApp}
                                                            </a>
                                                        ) : (
                                                            <span>{item?.linkUrlApp}</span>
                                                        )}
                                                    </td>
                                                    <td>
                                                        {item?.adType === 'MAINTOP' ? (
                                                            <>
                                                                <div>
                                                                    {moment(item?.startDate).format('YYYY.MM.DD HH:mm')}{' '}
                                                                    ~
                                                                </div>
                                                                <div>
                                                                    {moment(item?.endDate).format('YYYY.MM.DD HH:mm')}
                                                                </div>
                                                                {getStatusText(item.startDate, item.endDate)}
                                                            </>
                                                        ) : (
                                                            <>
                                                                {formatDate(item?.startDate)} ~
                                                                {formatDate(item?.endDate)}
                                                                <br />
                                                                {getStatusText(item.startDate, item.endDate)}
                                                            </>
                                                        )}
                                                    </td>
                                                    <td>{item?.useYN === 'Y' ? '공개' : '비공개'}</td>
                                                    <td>
                                                        {formatNumberWithCommas(item?.selectCntMb)}
                                                    </td>
                                                    <td>
                                                        {formatNumberWithCommas(item?.visitedCntMb)}
                                                    </td>
                                                    <td>{formatDate(item?.addDate)}</td>
                                                </tr>
                                            </React.Fragment>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={11}>데이타가 없습니다.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            <Pagination pages={pages} />
                        </div>
                    </div>
                </div>
            </div>
            {isPopupVisible && (
                <div id="popup" className="reason-popup">
                    <div className="overlay" onClick={handlePopupClose} />
                    <div className="popup-content" style={{ top: '45%' }}>
                        {/* <div className="popup-close" onClick={handlePopupClose} /> */}
                        <div className="popup-title">줄광고 노출위치 변경</div>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                margin: '30px 0',
                            }}
                        >
                            줄광고 노출위치 :{' '}
                            <input
                                style={{
                                    width: '100px',
                                    border: '1px solid #ddd',
                                    padding: '5px 15px',
                                    margin: '0 5px',
                                }}
                                type="number"
                                value={valueChangePosition}
                                onChange={onChangeValuePosition}
                            />{' '}
                            번째
                        </div>
                        <div className="groupButton">
                            <button
                                className="popup-button"
                                style={{ width: '60px', padding: '8px 15px' }}
                                onClick={() => {
                                    handleChangeValuePosition();
                                }}
                            >
                                변경
                            </button>
                            <button
                                className="popup-button"
                                style={{ width: '60px', padding: '8px 15px' }}
                                onClick={handlePopupClose}
                            >
                                취소
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
export default MAEAA010;
